import { ComponentRendering } from '@sitecore-jss/sitecore-jss-react';
import { TModelsListing, TModelsListingItemData, TModelsListingProps, TProductCard } from '../types/modelsListing.types';
import { StringField } from '../../../types/types';
import { LinkField } from '@sitecore-jss/sitecore-jss-react/types/components/Link';
import { appendRootToRichTextInternalLinks } from '../../../utils/appendRootToRichTextInternalLinks.utils';
import { appendRootToInternalLink } from '../../../utils/appendRootToInternalLink.utils';

export class ModelsListingModel {
  private readonly data?: TModelsListing;
  private readonly itemData?: TModelsListingItemData;
  private readonly params?: ComponentParamsGeneral;
  private readonly rendering?: ComponentRendering;
  private readonly isComponentUnreleased?: boolean;

  constructor(props: TModelsListingProps) {
    this.data = props?.fields?.apiData;
    this.itemData = props?.fields?.itemData;
    this.rendering = props?.rendering;
    this.params = props?.params;
    this.isComponentUnreleased = props?.fields?.isComponentUnreleased;
  }

  get thumbnailEE(): string {
    return this.itemData?.thumbnail || '';
  }

  get componentName(): string {
    return this.rendering?.componentName || '';
  }

  get items(): TProductCard[] {
    return (this.data?.items || []).filter((item) => !item.hideInModelsListing);
  }

  get total(): number | undefined {
    return this.data?.total;
  }

  get button1(): LinkField {
    return {
      value: {
        href: appendRootToInternalLink(this.data?.button1?.url),
        text: this.data?.button1?.label,
        target: this.data?.button1?.target,
      },
    };
  }

  get eyebrow(): StringField {
    return { value: this.data?.eyebrow };
  }

  get description(): StringField {
    return { value: appendRootToRichTextInternalLinks(this.data?.description) };
  }

  get title(): StringField {
    return { value: this.data?.title };
  }

  get subtitle(): string | undefined {
    return this.data?.subtitle;
  }

  get baseUrl(): string {
    let baseUrl = this.itemData?.contextItemUrl || '';
    if (baseUrl && this.params?.enableProductParameters === '1') {
      const lineId = this.params?.lineId;
      const serieId = this.params?.serieId;
      baseUrl = lineId ? `${baseUrl}/${lineId}` : baseUrl;
      baseUrl = serieId ? `${baseUrl}/${serieId}` : baseUrl;
    }
    return baseUrl;
  }

  get bodyTextVisibility(): 'show' | 'hide' {
    return this.params?.bodyTextVisibility;
  }

  get bodySpecVisibility(): 'show' | 'hide' {
    return this.params?.bodySpecVisibility;
  }

  get isUnreleased(): boolean {
    return !!this.isComponentUnreleased;
  }
}
